{
    "collage": {
        "skin": "default",
        "viewers": {
            "projectViewer": {
                "toolbar": true,
                "viewToolbar": {
                    "3D": [
                        "resetExtent",
                        "toogleProjection",
                        "frontImage",
                        "orientation",
                        "namedViews",
                        "vr",
                        "previous",
                        "next",
                        "changeView",
                        "vrPanorama",
                        "drawingRule",
                        "lidarProperties",
                        "fill",
                        "split"
                    ],
                    "map": ["changeView", "split", "fill"],
                    "table": ["changeView", "split", "fill"],
                    "gallery": ["inspectLocation", "changeView", "split", "fill"],
                    "section": ["flip", "scale", "multiSegment", "changeView", "fill", "split"]
                },
                "tools": {
                    "3D": [
                        "information",
                        "measure",
                        "buffer",
                        "annotation",
                        "layerEdition",
                        "saveview",
                        "screenshot",
                        "pointEdition",
                        "virtualTour"
                    ],
                    "forbidden3DEmbed": ["annotation", "layerEdition", "saveview", "screenshot", "pointEdition"],
                    "hiddenToolsByManipulator": {
                        "firstPerson": ["virtualTour"]
                    },
                    "placementTooltip": "right"
                },
                "featureContainer": true,
                "views": ["3D", "map", "section", "table", "gallery"],
                "leftPanelTabs": ["toc", "workflow", "preferences"],
                "rightPanelTabs": ["toolsAndProps"],
                "forbiddenEmbedTabs": ["workflow"],
                "workflowName": "GenericWorkflow",
                "compass": {
                    "3D": "",
                    "2D": ""
                },
                "layerCommands": ["AddLayer", "CreateLayer", "EditPermissions"],
                "toc": {
                    "icons": {
                        "scanners": "new-scanners",
                        "3d-model": "new-3d-model",
                        "vectorlayer": "new-layer",
                        "annotation": "new-annotation",
                        "panorama": "new-panorama",
                        "scanner-folder": "scan-folder"
                    }
                }
            },
            "scanProjectViewer": {
                "toolbar": true,
                "viewToolbar": {
                    "3D": [
                        "resetExtent",
                        "toogleProjection",
                        "orientation",
                        "namedViews",
                        "vr",
                        "changeView",
                        "drawingRule",
                        "previous",
                        "next",
                        "vrPanorama",
                        "frontImage",
                        "split",
                        "fill"
                    ],
                    "map": ["changeView", "split", "fill"],
                    "table": ["changeView", "split", "fill"],
                    "section": ["flip", "scale", "multiSegment", "changeView", "fill", "split"]
                },
                "tools": {
                    "3D": [
                        "information",
                        "measure",
                        "buffer",
                        "annotation",
                        "layerEdition",
                        "saveview",
                        "screenshot",
                        "pointEdition",
                        "virtualTour"
                    ],
                    "hiddenToolsByManipulator": {
                        "firstPerson": ["virtualTour"]
                    },
                    "placementTooltip": "top"
                },
                "featureContainer": true,
                "views": ["3D", "map", "section", "table"],
                "leftPanelTabs": ["toc", "workflow", "preferences"],
                "rightPanelTabs": ["toolsAndProps"],
                "workflowName": "ScanWorkflow",
                "compass": {
                    "3D": "",
                    "2D": ""
                },
                "layerCommands": ["AddLayer", "EditPermissions"],
                "progressBar": true,
                "tableCudButtons": true,
                "scannerCommunicationBtns": false,
                "autoPairBtnVisible": false,
                "toc": {
                    "categoriesSorted": {
                        "LayerGroup": ["wksLast"]
                    },
                    "icons": {
                        "scanners": "new-scanners",
                        "3d-model": "new-3d-model",
                        "vectorlayer": "new-layer",
                        "annotation": "new-annotation",
                        "panorama": "new-panorama",
                        "scanner-folder": "scan-folder"
                    }
                }
            },
            "jobSiteViewer": {
                "toolbar": true,
                "featureContainer": true,
                "views": ["3D", "map", "table"],
                "leftPanelTabs": ["toc"],
                "rightPanelTabs": ["toolsAndProps"],
                "viewToolbar": {
                    "3D": ["resetExtent", "changeView", "timeline", "split", "fill"],
                    "map": ["changeView", "split", "fill"],
                    "table": ["changeView", "split", "fill"]
                },
                "tools": {
                    "3D": ["information", "measure", "screenshot"]
                },
                "toc": {
                    "icons": {
                        "scanners": "new-scanners",
                        "3d-model": "new-3d-model",
                        "vectorlayer": "new-layer",
                        "annotation": "new-annotation",
                        "panorama": "new-panorama",
                        "scanner-folder": "scan-folder"
                    }
                }
            }
        },
        "projects": {
            "customColumns": ["jobSites"]
        },
        "createProject": {
            "scan": {
                "forbiddenFields": ["geoid"]
            },
            "generic": {
                "forbiddenFields": ["geoid"]
            }
        },
        "logo": "assets/img/Magnet_CollageWeb_Logo_Blue_RGB.svg",
        "title": "Collage Web",
        "legal": {
            "legalTerms": {
                "modal": true,
                "en": "assets/templates/legal_en.tpl.html",
                "ja": "assets/templates/legal_ja.tpl.html",
                "es": "assets/templates/legal_es.tpl.html",
                "zh": "assets/templates/legal_en.tpl.html",
                "it": "assets/templates/legal_en.tpl.html",
                "de": "assets/templates/legal_en.tpl.html",
                "fr": "assets/templates/legal_en.tpl.html",
                "pt": "assets/templates/legal_en.tpl.html",
                "nl": "assets/templates/legal_en.tpl.html"
            },
            "privacyPolicy": {
                "modal": true,
                "en": "assets/templates/privacy_en.tpl.html",
                "ja": "assets/templates/privacy_ja.tpl.html",
                "es": "assets/templates/privacy_es.tpl.html",
                "zh": "assets/templates/privacy_en.tpl.html",
                "it": "assets/templates/privacy_en.tpl.html",
                "de": "assets/templates/privacy_en.tpl.html",
                "fr": "assets/templates/privacy_en.tpl.html",
                "pt": "assets/templates/privacy_en.tpl.html",
                "nl": "assets/templates/privacy_en.tpl.html"
            }
        },
        "help": {
            "development": {
                "en": "https://s3-eu-west-1.amazonaws.com/collage-web-help-development/en-us/",
                "ja": "https://s3-eu-west-1.amazonaws.com/collage-web-help-development/ja/",
                "es": "https://s3-eu-west-1.amazonaws.com/collage-web-help-development/es-es/",
                "zh": "https://s3-eu-west-1.amazonaws.com/collage-web-help-development/en-us/",
                "it": "https://s3-eu-west-1.amazonaws.com/collage-web-help-development/it/",
                "de": "https://s3-eu-west-1.amazonaws.com/collage-web-help-development/de/",
                "fr": "https://s3-eu-west-1.amazonaws.com/collage-web-help-development/fr-fr/",
                "pt": "https://s3-eu-west-1.amazonaws.com/collage-web-help-development/pt/",
                "nl": "https://s3-eu-west-1.amazonaws.com/collage-web-help-development/nl/"
            },
            "testing": {
                "en": "https://s3-eu-west-1.amazonaws.com/collage-web-help-testing/en-us/",
                "ja": "https://s3-eu-west-1.amazonaws.com/collage-web-help-testing/ja/",
                "es": "https://s3-eu-west-1.amazonaws.com/collage-web-help-testing/es-es/",
                "zh": "https://s3-eu-west-1.amazonaws.com/collage-web-help-testing/en-us/",
                "it": "https://s3-eu-west-1.amazonaws.com/collage-web-help-testing/it/",
                "de": "https://s3-eu-west-1.amazonaws.com/collage-web-help-testing/de/",
                "fr": "https://s3-eu-west-1.amazonaws.com/collage-web-help-testing/fr-fr/",
                "pt": "https://s3-eu-west-1.amazonaws.com/collage-web-help-testing/pt/",
                "nl": "https://s3-eu-west-1.amazonaws.com/collage-web-help-testing/nl/"
            },
            "preproduction": {
                "en": "https://s3-eu-central-1.amazonaws.com/collage-web-help-preproduction/en-us/",
                "ja": "https://s3-eu-central-1.amazonaws.com/collage-web-help-preproduction/ja/",
                "es": "https://s3-eu-central-1.amazonaws.com/collage-web-help-preproduction/es-es/",
                "zh": "https://s3-eu-central-1.amazonaws.com/collage-web-help-preproduction/en-us/",
                "it": "https://s3-eu-central-1.amazonaws.com/collage-web-help-preproduction/it/",
                "de": "https://s3-eu-central-1.amazonaws.com/collage-web-help-preproduction/de/",
                "fr": "https://s3-eu-central-1.amazonaws.com/collage-web-help-preproduction/fr-fr/",
                "pt": "https://s3-eu-central-1.amazonaws.com/collage-web-help-preproduction/pt/",
                "nl": "https://s3-eu-central-1.amazonaws.com/collage-web-help-preproduction/nl/"
            },
            "qa": {
                "en": "https://collage-web-help-qa.magnet-enterprise.com/en-us/",
                "ja": "https://collage-web-help-qa.magnet-enterprise.com/ja/",
                "es": "https://collage-web-help-qa.magnet-enterprise.com/es-es/",
                "zh": "https://collage-web-help-qa.magnet-enterprise.com/en-us/",
                "fr": "https://collage-web-help-qa.magnet-enterprise.com/fr-fr/",
                "it": "https://collage-web-help-qa.magnet-enterprise.com/it/",
                "de": "https://collage-web-help-qa.magnet-enterprise.com/de/",
                "pt": "https://collage-web-help-qa.magnet-enterprise.com/pt/",
                "nl": "https://collage-web-help-qa.magnet-enterprise.com/nl/"
            },
            "production": {
                "en": "https://collage-web-help.magnet-enterprise.com/en-us/",
                "ja": "https://collage-web-help.magnet-enterprise.com/ja/",
                "es": "https://collage-web-help.magnet-enterprise.com/es-es/",
                "zh": "https://collage-web-help.magnet-enterprise.com/en-us/",
                "it": "https://collage-web-help.magnet-enterprise.com/it/",
                "de": "https://collage-web-help.magnet-enterprise.com/de/",
                "fr": "https://collage-web-help.magnet-enterprise.com/fr-fr/",
                "pt": "https://collage-web-help.magnet-enterprise.com/pt/",
                "nl": "https://collage-web-help.magnet-enterprise.com/nl/"
            }
        },
        "imgFolder": "assets/img/",
        "iconTranslation": {
            "cloud-to-cloud": "pointcloud",
            "localize": "camera",
            "visual-alignment": "camera",
            "occupation-backsight": "camera",
            "point-resection": "camera",
            "optimize": "camera",
            "edit-localization": "gears",
            "data": "document",
            "import-scan-as-station": "upload",
            "import-references": "upload",
            "import-project": "upload",
            "upgrade-sparse-scan": "download",
            "link-station": "link",
            "add-remove-multiple-links": "delete",
            "georeferencing": "geo-positioning"
        },
        "layers": {
            "hiddenCategories": ["Verity Model", "Machinery"]
        },
        "optimize": true
    },
    "verity": {
        "viewers": {
            "projectViewer": {
                "toolbar": false,
                "viewToolbar": {
                    "3D": ["changeView", "namedViews", "previous", "next", "split", "fill"],
                    "table": ["changeView", "split", "fill"]
                },
                "featureContainer": false,
                "views": ["3D", "table"],
                "leftPanel": "forbidden",
                "rightPanel": "forbidden",
                "grid": "forbidden",
                "compass": {
                    "3D": "",
                    "2D": ""
                }
            }
        },
        "logo": "assets/img/2016-Final-Verity-Logo-with-Icon-300ppi-01-copy.png",
        "title": "Verity Web Reports",
        "legal": {
            "legalTerms": {
                "modal": true,
                "en": "assets/templates/verity_legal_en.tpl.html",
                "ja": "assets/templates/verity_legal_ja.tpl.html",
                "es": "assets/templates/verity_legal_en.tpl.html",
                "zh": "assets/templates/verity_legal_en.tpl.html",
                "it": "assets/templates/verity_legal_en.tpl.html",
                "de": "assets/templates/verity_legal_en.tpl.html",
                "fr": "assets/templates/verity_legal_en.tpl.html"
            },
            "privacyPolicy": {
                "modal": false,
                "en": "https://www.clearedge3d.com/privacy/",
                "ja": "https://www.clearedge3d.com/privacy/",
                "es": "https://www.clearedge3d.com/privacy/",
                "zh": "https://www.clearedge3d.com/privacy/",
                "it": "https://www.clearedge3d.com/privacy/",
                "de": "https://www.clearedge3d.com/privacy/",
                "fr": "https://www.clearedge3d.com/privacy/"
            }
        },
        "help": {
            "development": {
                "en": "https://s3-eu-west-1.amazonaws.com/verity-web-help/latest/en-us/",
                "ja": "https://s3-eu-west-1.amazonaws.com/verity-web-help/latest/en-us/",
                "es": "https://s3-eu-west-1.amazonaws.com/verity-web-help/latest/en-us/",
                "zh": "https://s3-eu-west-1.amazonaws.com/verity-web-help/latest/en-us/",
                "it": "https://s3-eu-west-1.amazonaws.com/verity-web-help/latest/en-us/",
                "de": "https://s3-eu-west-1.amazonaws.com/verity-web-help/latest/en-us/",
                "fr": "https://s3-eu-west-1.amazonaws.com/verity-web-help/latest/en-us/"
            },
            "testing": {
                "en": "https://verity-web-help-alpha.pointcloudviz.com/latest/en-us/",
                "ja": "https://verity-web-help-alpha.pointcloudviz.com/latest/en-us/",
                "es": "https://verity-web-help-alpha.pointcloudviz.com/latest/en-us/",
                "zh": "https://verity-web-help-alpha.pointcloudviz.com/latest/en-us/",
                "it": "https://verity-web-help-alpha.pointcloudviz.com/latest/en-us/",
                "de": "https://verity-web-help-alpha.pointcloudviz.com/latest/en-us/",
                "fr": "https://verity-web-help-alpha.pointcloudviz.com/latest/en-us/"
            },
            "preproduction": {
                "en": "https://verity-web-help-beta.pointcloudviz.com/latest/en-us/",
                "ja": "https://verity-web-help-beta.pointcloudviz.com/latest/en-us/",
                "es": "https://verity-web-help-beta.pointcloudviz.com/latest/en-us/",
                "zh": "https://verity-web-help-beta.pointcloudviz.com/latest/en-us/",
                "it": "https://verity-web-help-beta.pointcloudviz.com/latest/en-us/",
                "de": "https://verity-web-help-beta.pointcloudviz.com/latest/en-us/",
                "fr": "https://verity-web-help-beta.pointcloudviz.com/latest/en-us/"
            },
            "qa": {
                "en": "https://verity-web-help-qa.magnet-enterprise.com/en-us/",
                "ja": "https://verity-web-help-qa.magnet-enterprise.com/en-us/",
                "es": "https://verity-web-help-qa.magnet-enterprise.com/en-us/",
                "zh": "https://verity-web-help-qa.magnet-enterprise.com/en-us/",
                "it": "https://verity-web-help-qa.magnet-enterprise.com/en-us/",
                "de": "https://verity-web-help-qa.magnet-enterprise.com/en-us/",
                "fr": "https://verity-web-help-qa.magnet-enterprise.com/en-us/"
            },
            "production": {
                "en": "https://verity-web-help.clearedge3d.com/latest/en-us/",
                "ja": "https://verity-web-help.clearedge3d.com/latest/en-us/",
                "es": "https://verity-web-help.clearedge3d.com/latest/en-us/",
                "zh": "https://verity-web-help.clearedge3d.com/latest/en-us/",
                "it": "https://verity-web-help.clearedge3d.com/latest/en-us/",
                "de": "https://verity-web-help.clearedge3d.com/latest/en-us/",
                "fr": "https://verity-web-help.clearedge3d.com/latest/en-us/"
            }
        },
        "imgFolder": "assets/img/"
    },
    "cr": {
        "skin": "cre",
        "extends": "collage",
        "viewers": {
            "scanProjectViewer": {
                "toolbar": true,
                "areToolbarsJoined": true,
                "viewToolbar": {
                    "3D": {
                        "position": {
                            "vertical": "bottom",
                            "horizontal": "center"
                        },
                        "tools": [
                            "resetExtent",
                            "orientation",
                            "frontImage",
                            "drawingRule",
                            "namedViews",
                            "previous",
                            "next",
                            "vrPanorama",
                            "visibility",
                            "split",
                            "fill",
                            "crViews"
                        ]
                    },
                    "table": ["split", "fill", "crViews"],
                    "section": ["flip", "scale", "multiSegment", "fill", "split", "crViews"],
                    "placementTooltip": "bottom"
                },
                "tools": {
                    "3D": ["information", "measure", "buffer", "annotation", "layerEdition", "saveview", "screenshot", "pointEdition"],
                    "forbidden3DNoTechPreview": ["virtualTour"],
                    "forbidden3D": [],
                    "hideContinuousMode": true,
                    "placementTooltip": "bottom"
                },
                "featureContainer": true,
                "views": ["3D", "table", "section"],
                "layoutViews": "row",
                "activeView": "floormap",
                "rightPanelTabs": ["toc", "toolsAndProps", "workflow", "preferences"],
                "showRightPanelCollapsed": true,
                "leftPanel": "forbidden",
                "compass": {
                    "3D": false,
                    "2D": "up"
                },
                "toc": {
                    "categoriesHidden": ["GLS Project", "ScansFolder"],
                    "categoriesCollapsed": ["Scan"],
                    "hideChildlessNodes": true,
                    "categoriesSorted": {
                        "Station": ["alphanum", "desc"]
                    },
                    "icons": {
                        "scanners": "scanners",
                        "3d-model": "new-3d-model",
                        "vectorlayer": "new-layer",
                        "annotation": "new-annotation",
                        "panorama": "new-panorama"
                    },
                    "iconSize": 30,
                    "hideProcessButton": true
                },
                "layerCommands": ["AddLayer", "CreateLayer", "EditCategories"],
                "forbiddenLayersTabBottomDownload": ["Panorama"],
                "grid": "forceOn",
                "gridColor": [0.7, 0.7, 0.7],
                "forbiddenProjectHeaderActions": ["share", "permissions", "diagnostics", "add", "create", "editCats"],
                "scannerCommunicationBtns": true,
                "autoPairBtnVisible": true,
                "batterySaver": "forceOn",
                "showEmptyTopBar": true,
                "showToolPanelOnToolSelection": true,
                "showHeatmapLegend": true
            }
        },
        "projects": {
            "filters": ["name", "ordering"],
            "forbiddenMenuOptions": ["EDIT_PERMISSIONS", "DEFAULT_VIEWER"],
            "showEmptyTopBar": true,
            "new": ["blank", "fromZip"],
            "defaultView": "grid",
            "customColumns": [""]
        },
        "layers": {
            "filters": ["name", "layerType", "category", "ordering", "onlyOrphan"],
            "forbiddenMenuOptions": ["EDIT_PERMISSIONS"],
            "createProject": "forbidden",
            "showEmptyTopBar": true
        },
        "jobSites": {
            "filters": ["name", "ordering", "dataType"],
            "showEmptyTopBar": true
        },
        "jobs": {
            "forbiddenColumns": ["cost"],
            "showEmptyTopBar": true
        },
        "createProject": {
            "scan": {
                "forbiddenFields": ["projection", "geoid"]
            },
            "showEmptyTopBar": true
        },
        "dashboard": {
            "forbidden": ["reports"],
            "showEmptyTopBar": true
        },
        "createLayer": {
            "showEmptyTopBar": true
        },
        "components": {
            "occbsRegistrationCurrent": {
                "hidden": {
                    "conditions": ["localStorage:userInterface:new"],
                    "operator": "OR"
                }
            },
            "occbsRegistrationNew": {
                "visible": {
                    "conditions": ["localStorage:userInterface:new", "ScanWorkflow:getState:RegistrationOccBs"],
                    "operator": "AND"
                }
            },
            "resectionRegistrationCurrent": {
                "hidden": {
                    "conditions": ["localStorage:userInterface:new"],
                    "operator": "OR"
                }
            },
            "resectionRegistrationNew": {
                "visible": {
                    "conditions": ["localStorage:userInterface:new", "ScanWorkflow:getState:RegistrationByRefs"],
                    "operator": "AND"
                }
            },
            "mainToolbarLeftNew": {
                "visible": false
            },
            "mainToolbarBottomNew": {
                "visible": false
            }
        },
        "iconTranslation": {
            "cloud-to-cloud": "cloud-to-cloud",
            "localize": "localize",
            "visual-alignment": "visual-alignment",
            "occupation-backsight": "occupation-backsight",
            "point-resection": "point-resection",
            "optimize": "optimize",
            "edit-localization": "edit-localization",
            "data": "data",
            "import-scan-as-station": "import-scan-as-station",
            "import-references": "import-references",
            "import-project": "import-project",
            "upgrade-sparse-scan": "upgrade-sparse-scan",
            "link-station": "link-station",
            "link": "workflow-link",
            "add-remove-multiple-links": "add-remove-multiple-links",
            "georeferencing": "geo-positioning"
        },
        "optimize": true,
        "toolsAndPropsCollapsableDefaults": {
            "toolsExpanded": {
                "information": true,
                "measure": true,
                "buffer": true,
                "screenshot": true,
                "saveview": true,
                "layerEdition": true,
                "annotation": true,
                "pointEdition": true,
                "virtualTour": true,
                "sides": true
            },
            "propertiesExpanded": {
                "information": true,
                "measure": false,
                "buffer": false,
                "screenshot": false,
                "saveview": false,
                "layerEdition": false,
                "annotation": false,
                "pointEdition": false,
                "virtualTour": false,
                "sides": false
            }
        }
    }
}
